import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAccount } from '@/frontastic';
import { CreditHistory } from '@/sdk/composable-commerce/types/payloads/AccountPayloads';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../ui/customAccordian/customAccordian';
import { Table } from '../../../ui/customTable/Table';
import Loader from '../../../ui/loader';
import Pagination from '../../../utils/pagination';
import { CREDIT_NOTES_ITEMS_PER_PAGE, PAYLOAD_QUERY, RESPONSE_SUCCESS_MESSAGE } from '../../constants';
import { notesTableHeaders } from '../../constants/tableFile';
import { FormattedNote } from '../../types';
import { transformNotes } from '../../utils';

const CustomerCreditNotes = ({ Texts, creditAccountId }: any) => {
  const [creditNotes, setCreditNotes] = useState<FormattedNote[]>([]);
  const params = useSearchParams();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState('');
  const { getCreditNotes } = useAccount();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);

  const getNotes = async (pageNumber?: number) => {
    setLoading(true);
    if (creditAccountId && PAYLOAD_QUERY.DIVISION_CODE) {
      const payload = {
        query: {
          creditAccountId: creditAccountId,
          divisionCode: params.get(PAYLOAD_QUERY.DIVISION_CODE),
          pageNumber: pageNumber ?? currentPage,
          pageSize: CREDIT_NOTES_ITEMS_PER_PAGE,
        },
      } as CreditHistory;
      await getCreditNotes(payload)
        .then((response) => {
          if (response?.code === RESPONSE_SUCCESS_MESSAGE) {
            const transformNoteToData = transformNotes(response?.Notes || []);
            setCreditNotes(transformNoteToData);
            setTotalItems(response?.quantity ?? 0);
          }
        })
        .catch(() => setLoading(false));
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (value) {
      getNotes();
    }
  }, [value]);

  const onPageChange = async (page: number) => {
    setCurrentPage(page);
    await getNotes(page);
  };

  return (
    <Accordion
      type="single"
      collapsible
      className="w-full rounded-md border border-foggyGray px-5 py-1 shadow-lg"
      onValueChange={setValue}
    >
      <AccordionItem value="creditNotes" className="border-none">
        <AccordionTrigger className="text-lg font-bold hover:no-underline">{Texts.creditNotes}</AccordionTrigger>
        <AccordionContent className="pb-5">
          {loading && <Loader />}
          <Table columns={notesTableHeaders} data={creditNotes} />
          <div>{creditNotes?.length === 0 ? Texts.noCustomerNotes : ''}</div>
          {totalItems > 5 && (
            <section className="mt-4 flex w-full items-center justify-end">
              <Pagination
                currentPage={currentPage}
                itemsPerPage={CREDIT_NOTES_ITEMS_PER_PAGE}
                totalItems={totalItems}
                onPageChange={onPageChange}
              ></Pagination>
            </section>
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default CustomerCreditNotes;
